// extracted by mini-css-extract-plugin
export default {"wrapper":"Preferences_wrapper__vJia6","infoBox":"Preferences_infoBox__jrVu7","header":"Preferences_header__ByFH-"};